import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

const routes: Routes = [


  {

    path: 'dashboard',
    loadChildren: () =>
      import('../modules/dashboard/dashboard.module').then((m)=> m.DashboardModule)

  },


  {
    path: 'eventos',
    redirectTo: '/admin/events',
    pathMatch: 'full',
  },

  {
    path: 'events',
    loadChildren: () =>
      import('../modules/events/event.module').then((m) => m.EventModule),
  },

  {
    path: 'companies',
    loadChildren: () =>
      import('../modules/companies/companies.module').then((m) => m.CompaniesModule),
  },

  {
    path: 'users',
    loadChildren: () =>
      import('../modules/users/users.module').then((m) => m.UsersModule),
  },

  {
    path: 'members',
    loadChildren: () =>
      import('../modules/user/user.module').then((m) => m.UserModule),
  },

  {
    path: 'networking-objectives',
    loadChildren: () =>
      import('../modules/networking-objectives/networking-objectives.module').then(
        (m) => m.NetworkingObjectivesModule
      ),
  },

  {
    path: 'training-information-areas',
    loadChildren: () =>
      import('../modules/training-information-areas/training-information-areas.module').then(
        (m) => m.TrainingInformationAreasModule
      ),
  },

  {
    path: 'event-participation-types',
    loadChildren: () =>
      import('../modules/event-participation-types/event-participation-types.module').then(
        (m) => m.EventParticipationTypesModule
      ),
  },

  {
    path: 'categories',
    loadChildren: () =>
      import('../modules/categories/categories.module').then((m) => m.CategoriesModule),
  },

  {
    path: 'interests',
    loadChildren: () =>
      import('../modules/interests/interests.module').then((m) => m.InterestsModule),
  },

  {
    path: 'content-preferences',
    loadChildren: () =>
      import('../modules/content-preferences/content-preferences.module').then(
        (m) => m.ContentPreferencesModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CoreRoutingModule {}
